import { memo } from 'react';
import { Center, Flex } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';

const ProjectsCasesIllustration = ({
  illustration,
  imgProps = null,
  cardScreen = null,
  cardScreenProps = null,
  ...props
}) => (
  <Flex
    w="full"
    pos="relative"
    borderRadius={{ mobile: '20px', laptop: '36px' }}
    overflow="hidden"
    {...props}
  >
    <NextImage
      loading="lazy"
      src={illustration}
      alt="Иллюстрация карточки кейса"
      w="full"
      h="auto"
      minH="full"
      pos="absolute"
      inset="0 auto auto 0"
      zIndex="0"
      {...imgProps}
    />

    {cardScreen && (
      <Center
        w="71.14%"
        aspectRatio="446 / 250"
        bg="bg.grayLight"
        p={{ mobile: '3px', laptop: '6px' }}
        borderRadius={{ mobile: '16px', laptop: '24px' }}
        pos="absolute"
        inset="auto auto -32px calc(50% - (71.14% / 2))"
        zIndex="1"
        {...cardScreenProps?.container}
      >
        <NextImage
          loading="lazy"
          src={cardScreen}
          alt="Скриншот продукта"
          w="full"
          h="full"
          borderRadius={{ mobile: '13px', laptop: '18px' }}
          {...cardScreenProps?.img}
        />
      </Center>
    )}
  </Flex>
);

export default memo(ProjectsCasesIllustration);
